import {
  applyOverrides,
  propertyBeingSoldCard as basePropertyBeingSoldCard,
} from '../../shared';

export const propertyBeingSoldCard = applyOverrides(basePropertyBeingSoldCard, {
  id: 'propertyInfo.propertyBeingPurchased',
  innerTitle: 'Property Being Purchased',
  layout: (layout) => [
    [
      {
        name: 'mlsAutofill',
        size: 100,
      },
    ],
    ...layout,
  ],
  fields: {
    mlsServiceId: {
      name: 'property.mlsServiceId',
      entity: 'property',
      label: 'MLS Vendor',
      type: 'hidden',
    },
    mlsNumber: {
      name: 'property.mlsNumber',
      entity: 'property',
      label: 'MLS Number',
      type: 'hidden',
    },
    mlsAutofill: {
      name: 'mlsAutofill',
      type: 'mlsAutofill',
      label: 'MLS AUTOFILL',
      action: {
        name: 'mlsAutofill',
        mlsAutofillFields: {
          vendorId: 'property.mlsServiceId',
          number: 'property.mlsNumber',
        },
        props: [
          {
            from: 'property.street1',
            to: 'property.street1',
          },
          {
            from: 'property.street2',
            to: 'property.street2',
          },
          {
            from: 'property.city',
            to: 'property.city',
          },
          {
            from: 'property.state',
            to: 'property.state',
          },
          {
            from: 'property.zip',
            to: 'property.zip',
          },
          {
            from: 'property.county',
            to: 'property.county',
          },
          {
            from: 'property.assessorParcelNumber',
            to: 'property.taxIdNumber',
          },
          {
            from: 'property.legalDescription',
            to: 'property.legalDescription',
          },
          {
            from: 'listingAgent.firstName',
            to: 'contacts.counterpartyAgent.0.firstName',
          },
          {
            from: 'listingAgent.lastName',
            to: 'contacts.counterpartyAgent.0.lastName',
          },
          {
            from: 'listingAgent.email',
            to: 'contacts.counterpartyAgent.0.email',
          },
          {
            from: 'listingAgent.cellPhone',
            to: 'contacts.counterpartyAgent.0.cellPhone',
          },
          {
            from: 'listingAgent.licenseNumber',
            to: 'contacts.counterpartyAgent.0.licenseNumber',
          },
          {
            from: 'listingAgent.brokerage.name',
            to: 'contacts.counterpartyAgent.0.brokerage.companyName',
          },
          {
            from: 'listingAgent.brokerage.licenseNumber',
            to: 'contacts.counterpartyAgent.0.brokerage.licenseNumber',
          },
          {
            from: 'listingAgent.brokerage.street1',
            to: 'contacts.counterpartyAgent.0.brokerage.street1',
          },
          {
            from: 'listingAgent.brokerage.street2',
            to: 'contacts.counterpartyAgent.0.brokerage.street2',
          },
          {
            from: 'listingAgent.brokerage.city',
            to: 'contacts.counterpartyAgent.0.brokerage.city',
          },
          {
            from: 'listingAgent.brokerage.state',
            to: 'contacts.counterpartyAgent.0.brokerage.state',
          },
          {
            from: 'listingAgent.brokerage.zip',
            to: 'contacts.counterpartyAgent.0.brokerage.zip',
          },
          {
            from: 'coListingAgent.firstName',
            to: 'contacts.counterpartyAgent.1.firstName',
          },
          {
            from: 'coListingAgent.lastName',
            to: 'contacts.counterpartyAgent.1.lastName',
          },
          {
            from: 'coListingAgent.email',
            to: 'contacts.counterpartyAgent.1.email',
          },
          {
            from: 'coListingAgent.cellPhone',
            to: 'contacts.counterpartyAgent.1.cellPhone',
          },
          {
            from: 'coListingAgent.licenseNumber',
            to: 'contacts.counterpartyAgent.1.licenseNumber',
          },
          {
            from: 'coListingAgent.brokerage.name',
            to: 'contacts.counterpartyAgent.1.brokerage.companyName',
          },
          {
            from: 'coListingAgent.brokerage.licenseNumber',
            to: 'contacts.counterpartyAgent.1.brokerage.licenseNumber',
          },
          {
            from: 'coListingAgent.brokerage.street1',
            to: 'contacts.counterpartyAgent.1.brokerage.street1',
          },
          {
            from: 'coListingAgent.brokerage.street2',
            to: 'contacts.counterpartyAgent.1.brokerage.street2',
          },
          {
            from: 'coListingAgent.brokerage.city',
            to: 'contacts.counterpartyAgent.1.brokerage.city',
          },
          {
            from: 'coListingAgent.brokerage.state',
            to: 'contacts.counterpartyAgent.1.brokerage.state',
          },
          {
            from: 'coListingAgent.brokerage.zip',
            to: 'contacts.counterpartyAgent.1.brokerage.zip',
          },
          {
            from: 'photos',
            to: 'photos',
          },
        ],
      },
    },
  },
});
